module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./VirtualPointView.js"));
	}, "VirtualPointView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=VirtualPointView!./src/pages/Shop/Member/Personal/VirtualPoint/VirtualPointView.js
// module id = 1892
// module chunks = 367